module.exports = __webpack_public_path__ + "img/huanong.0a97baf4.jpg";